<div class="absolute w-screen h-screen overflow-hidden inset-0 bg-primary-700 z-200">
	@if (loading()) {
		<ui-spinner></ui-spinner>
	} @else if (vehicles().length < multipleMinimalVehicles) {
		<single-vehicle [data]="data()" [year]="year"></single-vehicle>
	} @else {
		<multiple-vehicles [data]="data()" [vehicles]="vehicles()" [year]="year"></multiple-vehicles>
	}
</div>
